<template>
  <div class="main-container">
    <div class="home-revm-info-boxes">
      <InfoBoxes />
    </div>
    <div class="chartsandalerts-container">
      <div class="charts-container">
        <div class="row-chart-1">
          <div class="health-donut-chart fade-in-animation">
            <ApmHealthIndicator />
          </div>
          <div class="users-line-chart fade-in-animation">
            <UsersImpactInfo />
          </div>
        </div>
        <div class="fade-in-animation top-response-time">
          <TopResponsetimeApps></TopResponsetimeApps>
        </div>
      </div>
      <div class="alerts">
        <AlertInfo />
      </div>
    </div>
  </div>
</template>
<script>
import InfoBoxes from './info-boxes.vue';
import AlertInfo from './alert-info.vue';
import ApmHealthIndicator from './apm-health-indicator.vue';
import UsersImpactInfo from './users-impact-info.vue';
import TopResponsetimeApps from './application-response.vue';
export default {
  components: {
    InfoBoxes,
    AlertInfo,
    ApmHealthIndicator,
    UsersImpactInfo,
    TopResponsetimeApps,
  },
};
</script>
<style>
.main-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 0.8rem;
}
.home-revm-info-boxes {
  display: flex;
}
.chartsandalerts-container {
  display: flex;
  gap: 1%;
  align-items: stretch;
  justify-content: space-between;
}

.health-donut-chart {
  display: flex;
  margin-right: 1.275em;
  margin-top: 0.125em;
  margin-left: 0.125em;
  height: 23em;
  flex-grow: 0.2;
  flex-shrink: 2;
  flex-basis: auto;
  align-items: center;
}
.charts-container {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  width: 74%;
}
.alerts {
  display: flex;
  width: 25%;
}
.row-chart-1 {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  margin-bottom: 1.2rem;
}
.users-line-chart {
  display: flex;
  flex-grow: 2;
  flex-shrink: 2;
  flex-basis: auto;
}
</style>
